import React from 'react';

function CustomButton({ text, onClick }) {
  return (
    <>
      <button className="custom_button" onClick={onClick}>
        {text}
      </button>
      <style jsx>{`
      .custom_button{
        font-family: "DIN 2014;"
        font-size: 13px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        padding: 12px 24px;
        color: #E4E4E4;
        background: #950810;
        border:none;
        border-radius: 4px;
      }
    `}</style>
    </>
  );
}

export default CustomButton;
